export default __webpack_public_path__ + "static/media/allFeatures.622aeafd.svg";